import { all } from 'redux-saga/effects';
import mailClassesWatcher from './MailClassesWatcher';

function* productSelectorSaga() {
  yield all([
    mailClassesWatcher(),
  ]);
}

export default productSelectorSaga;
